import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { COMPONENTS } from '../../../../routers/constants'
import { LinkComponent } from '../../../common/html/LinkComponent'
import { TitleComponent } from '../../../common/html/TitleComponent'

export const Header = ({ isNoData }) => {
  return (
    <>
      <div className="dFlex justifyContentBetween gap2">
        <div className="dFlex flex1 flexWrap">
          <TitleComponent
            title="dashboard.totalAlert.title"
            style={{ whiteSpace: 'nowrap' }}
          />
        </div>
        {!isNoData && (
          <div>
            <LinkComponent href={`${COMPONENTS.alerts.route}`}>
              <Element
                style={{
                  padding: '4px 10px',
                  lineHeight: '16px',
                  backgroundColor: '#EDF5FE',
                  color: '#2C73E8',
                }}
              >
                <Translate value="dashboard.totalAlert.viewAllAlert" />
              </Element>
            </LinkComponent>
          </div>
        )}
      </div>
    </>
  )
}
